import { injectable } from 'inversify';
import { UnitOptionOrganisationMode } from '@Models';
import { unit_option_full } from '@Api';

@injectable()
export class UnitOptionOrganisationModeMapper {
  public map(
    item: unit_option_full.organisation_mode,
  ): UnitOptionOrganisationMode {
    switch (item) {
      case unit_option_full.organisation_mode.CHANGE_UNIT_ORGANISATION:
        return UnitOptionOrganisationMode.ChangeUnitOrganisation;
      case unit_option_full.organisation_mode.EXCLUDE_ADD_ORGANISATION:
        return UnitOptionOrganisationMode.ExcludeAddOrganisation;
    }
    return UnitOptionOrganisationMode.Unit;
  }
}
